import styled from '@emotion/styled'
import { Form } from 'antd'
import { InjectedFormProps, reduxForm } from 'redux-form'
import Button from '../../../components/common/Button'
import { InputField } from '../../../components/common/fields'
import { SHOP_PRIMARY } from '../../../constant/colors'
import { mobile, useScreen } from '../../../utils/responsive-helper'
import { CheckCouponValues } from '../../../services/coupon/coupon-typed'

const FormLayout = styled(Form)`
  padding-top: 24px;
  display: flex;
  gap: 24px;

  ${mobile} {
    padding-top: 0px;
    gap: 8px;
  }
`

const InputFieldStyled = styled(InputField)`
  width: 100%;
  border-radius: 4px;
`

const enchancer = reduxForm<CheckCouponValues>({
  form: 'SearchCouponform',
})

type SearchCouponFormProps = InjectedFormProps<CheckCouponValues>

const SearchCouponForm = (props: SearchCouponFormProps) => {
  const { isMobile } = useScreen()
  const { handleSubmit } = props

  return (
    <FormLayout>
      <InputFieldStyled name="coupon" placeholder="กรอกรหัสส่วนลด" />
      <Button
        onClick={handleSubmit}
        style={{ backgroundColor: SHOP_PRIMARY, width: isMobile ? 92 : 204, borderRadius: 100 }}
      >
        ตกลง
      </Button>
    </FormLayout>
  )
}

export default enchancer(SearchCouponForm)
